import { memo, ReactNode } from 'react';
import './patchWaveformData';

interface Props {
  readonly width: number;
  readonly height: number;
  readonly x?: number;
  readonly bgColor?: string;
  readonly debug?: string | false;
  readonly startTs: number;
  readonly duration: number;
  readonly children: ReactNode;
}

export const WaveformEl = memo(function Waveform(p: Props) {
  const { x, width, height, bgColor, debug, startTs, duration, children } = p;

  return (
    <g
      data-testid="waveform-el"
      data-ts={startTs}
      data-datetime={new Date(startTs).toISOString()}
      data-duration={duration}
      transform={`translate(${x! - 1 || 0},0)`}
    >
      {debug && (
        <text y={20} fontSize="14">
          {debug}
        </text>
      )}
      <rect width={width + 2} height={height} fill={bgColor} />
      {children}
    </g>
  );
});

(WaveformEl as any).defaultProps = {
  x: 0,
  bgColor: 'transparent',
} as Partial<Props>;
